export default "__VITE_ASSET__70822a03__"